import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { SharedService } from '../../_service/shared.service';
import { PageEvent, MatPaginator } from '@angular/material/paginator';
import { LeadsService } from '../../_service/leads.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
declare var $: any;


@Component({
  selector: 'app-affiliate-leads',
  templateUrl: './affiliate-leads.component.html',
  styleUrls: ['./affiliate-leads.component.css']
})
export class AffiliateLeadsComponent implements OnInit {

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('dateRangeStart', { static: false }) dateRangeStart: ElementRef;
  @ViewChild('dateRangeEnd', { static: false }) dateRangeEnd: ElementRef;

  perpage: number = 25; leadList: any = []; length: number = 0; pageEvent: PageEvent; loading: boolean = true; role: string;pageSizeOptions = [10, 25, 50, 100]; pageIndex: number = 0; loaded: boolean = false;search: string; currentUserId: any; booleanValue: any = false;treatment='';treatments=[];treatments_copy=[];city="";cities=[];cities_copy=[];start_date: string = ''; end_date: string = '';cm_access='';

  constructor(private sharedapi: SharedService, public leadapi: LeadsService, private dialog: MatDialog) { }

  ngOnInit(): void {
    this.sharedapi.getCMAccess().subscribe((item:string) => {this.cm_access=item});
    this.sharedapi.getLeadSourceOfUser()
    this.role = localStorage.getItem('role');
    this.getTreatment();this.getcitiesList();
    this.cm_access = localStorage.getItem('CMAccess');
  }


  ngAfterViewInit() {
    this.loadLeads(0, this.perpage);
  }

  setSearchValue(type){
    if(type=='treatment'){
      $("#treatmentSearch").val('');
      $("#treatmentSearch").focus();
      this.treatments= this.treatments_copy;
    } else if(type=='city'){
        $("#citySearch").val('');
        $("#citySearch").focus();
        this.cities= this.cities_copy;
    }
  }

  searchOnSelect(searchtText: string, type){
    if (type == 'treatment') {
      this.treatments = this.sharedapi.searchData(searchtText, this.treatments_copy, "name");
    } else if(type == 'city') {
      this.cities = this.sharedapi.searchData(searchtText, this.cities_copy, "name");
    }
  }

  async loadLeads(pageIndex, perpage) {
    this.leadList = [];
    this.paginator.pageIndex = pageIndex;
    let qString = 'search='+this.search+'&treatment='+this.treatment+'&city='+this.city+'&date_range=' + this.start_date + '-' + this.end_date;
    this.loading = true; this.loaded = false;
    await this.leadapi.getAffiliateUserLeads(this.paginator.pageIndex, perpage, qString)
    .subscribe((data: any) => {
      this.length = parseInt(data.totaldata);
      this.loading = false;
      this.loaded = true;
      if (data.status) {
        this.leadList = data.data;
      } else {
        this.leadList = [];
        this.sharedapi.presentToast(data.msg);
      }
    }, error => {
      this.loading = false;
      this.loaded = true;
      this.sharedapi.checkError(error);
    });
  }


  pageChange(event) {
    this.pageIndex = event.pageIndex;
    this.loadLeads(event.pageIndex, event.pageSize);
  }

  public getServerData(event: PageEvent): any {
    this.perpage = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.loadLeads(event.pageIndex, event.pageSize);
  }

  async getTreatment()
  {
     await this.leadapi.getTreatments().subscribe((data:any) => {
          if(data.status)
          {
              this.treatments = data.data;
              this.treatments_copy = this.treatments;
          }else{
              this.treatments = [];
          }
      }, error => {
          this.sharedapi.checkError(error);
      });
  }

  async getcitiesList()
  {
      await this.leadapi.getcities().subscribe((data:any) => {
          if(data.status)
          {
              this.cities = data.data;
              this.cities_copy= this.cities;
          }else{
              this.cities = [];
          }
      }, error => {
          this.sharedapi.checkError(error);
      });
  }

  dateRangeChange(date1, date2) {
    if (date2.value) {
      this.start_date = date1.value;
      this.end_date = date2.value;
    }
  }

  resetFilters(){
    this.clearDate();
    this.search = '';this.treatment = ''; this.city = '';
    this.loadLeads(0,25);
  }

  clearDate() {
    this.dateRangeStart.nativeElement.value = "";
    this.dateRangeEnd.nativeElement.value = "";
    this.start_date = '';
    this.end_date = '';
  }

}
